var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialogWrapper",
      attrs: {
        top: "0px",
        width: "1100px",
        title: "订单供应点同步",
        visible: _vm._dialogVisible,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm._dialogVisible = $event
        },
      },
    },
    [
      _c(
        "hx-table-result",
        [
          _c("hx-table-result-col", [
            _c("div", { staticClass: "wrap-table-info-display" }, [
              _c("span", { staticClass: "table-info-display" }, [
                _c("span", [_vm._v("总条数：")]),
                _c("span", { staticClass: "alert-text ft16" }, [
                  _vm._v(_vm._s(_vm.tableData.length)),
                ]),
              ]),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("icTableColumnIndex", {
                attrs: { pageIndex: 1, pageSize: 999999 },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", align: "center", label: "订单编号" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "buyerMobile",
                  align: "center",
                  label: "用户电话",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  align: "center",
                  label: "订单总额",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyDate",
                  align: "center",
                  label: "领货日期",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsSiteName",
                  align: "center",
                  label: "旧供应点",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "newSiteName",
                  align: "center",
                  label: "新供应点",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyLevelName",
                  align: "center",
                  label: "保障级别",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatus",
                  align: "center",
                  label: "订单状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.orderStatusMap[scope.row.orderStatus])
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(scope.row)
                              },
                            },
                          },
                          [_vm._v("更新供应点")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }